import { useState } from 'react';

import styles from './Tabs.module.scss';

type Tab = {
  label: string;
  key: number | string;
};

interface TabsProps {
  tabs: Tab[] | [];
  children: (active: number | string) => React.ReactNode;
}

export const Tabs = ({ tabs, children }: TabsProps) => {
  const [active, setActive] = useState(tabs[0]?.key);

  const handleChange = (value: number | string) => setActive(value);

  return (
    <>
      {tabs.length > 1 && (
        <div className={styles.tabs} role="tablist">
          {tabs.map((tab, index) => (
            <button
              aria-controls={`panel-${tab.key}`}
              aria-selected={tab.key === active}
              className={styles.tab}
              id={`tab-${tab.key}`}
              key={index}
              onClick={() => handleChange(tab.key)}
              role="tab"
            >
              {tab.label}
            </button>
          ))}
        </div>
      )}

      {children(active)}
    </>
  );
};
